// Querys and Mutations
import {
  SEARCH_AND_CREATE,
  CREATE,
  GET_BY_ID,
  UPDATE,
  GET_WITH_PAGINATION,
  DELETE_BY_ID,
  GET_ALL,
  EXIST_TASKSHEET
} from '@/graphql/taskSheet/taskSheetGraphql'

// models
import {
  FiltersFormModel,
  ResultSearch,
  CreateTaskSheetInput,
  TaskSheetModel,
  TaskSheetsWithPaginationModel,
  FilterTaskSheet,
  ExistTaskSheet
} from '@/models/taskSheet'

// apollo
import { apolloClient } from '@/apollo'

class TaskSheetService {
  /**
   * Queries
   */
  async searchAndCreateTaskSheet (filters: FiltersFormModel, date: string): Promise<ResultSearch> {
    const result = await apolloClient.query({
      query: SEARCH_AND_CREATE,
      variables: {
        filters: filters,
        date: date
      }
    })
    return result.data.searchAndCreateTaskSheet
  }

  async existsTaskSheetByFilters (filters: FiltersFormModel, date: string): Promise<ExistTaskSheet> {
    const result = await apolloClient.query({
      query: EXIST_TASKSHEET,
      variables: {
        filters: filters,
        date: date
      }
    })
    return result.data.existsTaskSheetByFilters
  }

  async getById (id: number): Promise<TaskSheetModel|null> {
    return new Promise((resolve, reject) => {
      apolloClient.query({
        query: GET_BY_ID,
        variables: {
          id: id
        }
      }).then(response => {
        resolve(response.data.getTaskById)
      }).catch(error => {
        reject(error)
      })
    })
  }

  async getWithPagination (perPage: number, page: number, filters: FilterTaskSheet): Promise<TaskSheetsWithPaginationModel> {
        const result = await apolloClient.query({
            query: GET_WITH_PAGINATION,
            variables: {
                page: page,
                perPage: perPage,
                filters: {
                  dateStart: filters.dateStart,
                  dateEnd: filters.dateEnd,
                  workType: filters.workType ? Number(filters.workType) : null,
                  headquarter: filters.headquarter ? Number(filters.headquarter) : null,
                  area: filters.area ? Number(filters.area) : null,
                  subarea: filters.subarea ? Number(filters.subarea) : null,
                  employee_id: filters.employee_id
                }
            }
        })
        return {
            pagination: result.data.taskSheetsWithPagination.paginatorInfo,
            objects: result.data.taskSheetsWithPagination.data
        }
    }

  async getAll (filters: FilterTaskSheet): Promise<TaskSheetModel[]> {
    const result = await apolloClient.query({
      query: GET_ALL,
      variables: {
        filters: {
          dateStart: filters.dateStart,
          dateEnd: filters.dateEnd,
          workType: filters.workType ? Number(filters.workType) : null,
          headquarter: filters.headquarter ? Number(filters.headquarter) : null
        }
      }
    })
    return result.data.taskSheets
  }

  /**
   * Mutations
   */
  async create (form: CreateTaskSheetInput): Promise<{ success: boolean; msg: string; data: TaskSheetModel|null }> {
    return new Promise((resolve, reject) => {
      apolloClient.mutate({
        mutation: CREATE,
        variables: {
          input: form
        }
      }).then(response => {
        if (response.errors && response.errors.length > 0) {
          resolve({
            success: false,
            data: null,
            msg: response.errors[0].message
          })
        } else {
          resolve({
            success: true,
            data: response.data.createTaskSheet,
            msg: ''
          })
        }
      }).catch(error => {
        reject(error)
      })
    })
  }

  async update (id: number, form: CreateTaskSheetInput): Promise<{ success: boolean; msg: string; data: TaskSheetModel|null }> {
    return new Promise((resolve, reject) => {
      apolloClient.mutate({
        mutation: UPDATE,
        variables: {
          input: form,
          id: id
        }
      }).then(response => {
        if (response.errors && response.errors.length > 0) {
          resolve({
            success: false,
            data: null,
            msg: response.errors[0].message
          })
        } else {
          resolve({
            success: true,
            data: response.data.createTaskSheet,
            msg: ''
          })
        }
      }).catch(error => {
        reject(error)
      })
    })
  }

  async delete (id: number): Promise<TaskSheetModel> {
    return new Promise((resolve, reject) => {
      apolloClient.mutate({
        mutation: DELETE_BY_ID,
        variables: {
          id: id
        }
      }).then(response => {
        resolve(response.data.deleteTaskSheet)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default new TaskSheetService()
